<template>
    <grid
        ref="grid"
        :headerHeight="70"
        :groupRowRendererParams="groupRowRendererParams"
        :isSearch="false"
        :columnDefs="columnDefs"
        :rowData="resources"
        :groupDisplayType="'groupRows'"
        :isGroupOpenByDefault="() => true"
    ></grid>
</template>

<script>
    import API from '../../../../api';
    import Grid from '../../../generic/grid/grid.vue';
    import RadioHeaderComponent from '../../../generic/grid/radio-header-component.vue';
    import GroupRowRenderer from './group-row-renderer.vue';
    import { TEAM_MEMBER_BY_ID_ENDPOINT } from '../../../../endpoints';

    export default {
        name: 'TeamMemberEditAccess',
        components: {
            Grid,
            groupRowRenderer: GroupRowRenderer,
            radioHeaderComponent: RadioHeaderComponent,
        },
        props: {
            teamMember: Object,
        },
        computed: {
            columnDefs() {
                return [
                    {
                        field: 'component',
                        rowGroup: true,
                        hide: true,
                    },
                    {
                        headerName: 'Name',
                        field: 'name',
                        minWidth: 300,
                    },
                    ...this.groups.map((group) => ({
                        type: 'yesNoColumn',
                        minWidth: 150,
                        headerName: group.name,
                        headerComponent: 'radioHeaderComponent',
                        headerComponentParams: {
                            valueGetter: () => this.teamMember.group_id,
                            radioName: 'change-access',
                            radioOption: () => group.id,
                            onChange: async ({ node, api }, newValue) => {
                                const groupID = newValue;

                                api.showLoadingOverlay();
                                try {
                                    await this.$store.dispatch('teamMember/updateAccess', {
                                        id: this.teamMember.id,
                                        group_id: groupID,
                                    });
                                } catch {
                                    this.errorToast({ text: `Could not update access for the team member.` });
                                    api.refreshHeader();
                                } finally {
                                    api.hideOverlay();
                                }
                            },
                        },
                        cellRendererParams: {
                            plain: true,
                            invisible: true,
                        },
                        valueGetter: ({ data }) => data && group.resource_ids.includes(data.id),
                    })),
                ];
            },
        },
        data() {
            return {
                busy: false,
                groups: [],
                resources: [],
                groupRowRendererParams: {
                    innerRenderer: 'groupRowRenderer',
                },
            };
        },
        mounted() {
            (async () => {
                this.busy = true;
                try {
                    await this.fetchAccess();
                } finally {
                    this.busy = false;
                }
            })();
        },
        methods: {
            async fetchAccess() {
                try {
                    const response = await API.get(TEAM_MEMBER_BY_ID_ENDPOINT(this.teamMember.id, 'access'));
                    this.groups = response.data.groups;
                    this.resources = response.data.resources;
                } catch (err) {
                    this.errorToast({ text: 'Could not load access data.' });
                }
            },
        },
    };
</script>
